module.exports = __webpack_public_path__ + "media/images/navbar-avatar-04dde867cb3a73ef514bfb9af89ebe28.svg";